import React from 'react';
import Status from 'design-system/Status';
import useColors from 'hooks/useColors';
const strings = {
    statusValueWorking: 'Working',
    statusValueNotWorking: 'Requires action',
    statusValueSyncing: 'Syncing',
};
export const LiveExportStatus = React.memo(({ active, syncInProgress }) => {
    const colors = useColors();
    return (<Status activeText={strings.statusValueWorking} inactiveText={syncInProgress
            ? strings.statusValueSyncing
            : strings.statusValueNotWorking} inActiveColor={syncInProgress ? colors.status.informational : undefined} active={!syncInProgress && active}/>);
});
LiveExportStatus.displayName = 'LiveExportStatus';
